import { RegistryFieldsType } from '@rjsf/utils';

import { StringField } from './StringField';

export const fields: RegistryFieldsType = {
	StringField,
};
